module.exports = __webpack_public_path__ + "static/logo-560d753e7572d637c39a1acf7a8ca9a7.png";